// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"325":"92b98c81","347":"718a82c0"}[chunkId] + ".chunk.js";
};